// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4fa302a7] .app-navigation-entry__title{color:var(--color-text-maxcontrast)}\n", ""]);
// Exports
module.exports = exports;
